import React from 'react';
import { connect } from 'react-redux';

import getSlotsByExpansionStatus from 'selectors/outfit/getSlotsByExpansionStatus';
import EquippedComponent from './EquippedComponent';
import { IAppState } from 'types/app';

export function EquippedContainer(props: Props) {
  const { groups } = props;
  return (
    <EquippedComponent
      groups={groups}
    />
  );
}

EquippedContainer.displayName = 'EquippedContainer';

interface Props {
  groups: { name: string }[],
}

const mapStateToProps = (state: IAppState) => ({
  groups: getSlotsByExpansionStatus(state),
});

export default connect(mapStateToProps)(EquippedContainer);